<template>
    <div class="center-page">
        <el-form inline label-width="120px" label-position="right">
            <el-form-item label="时间类型：">
                <el-select v-model="form.type">
                    <el-option v-for="item in timeType" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间选择：">
                <el-date-picker
                        v-model="form.time"
                        type="date"
                        v-if="form.type===1"
                        value-format="yyyy-MM-dd"
                        placeholder="选择时间">
                </el-date-picker>
                <el-date-picker
                        v-model="form.time"
                        type="month"
                        v-if="form.type===2"
                        value-format="yyyy-MM"
                        placeholder="选择时间">
                </el-date-picker>
                <el-date-picker
                        v-model="form.time"
                        type="year"
                        v-if="form.type===3"
                        value-format="yyyy"
                        placeholder="选择时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item style="margin-top: 40px;">
                <el-button type="primary" @click="landlordDataInfo">确认</el-button>
            </el-form-item>
        </el-form>
        <div class="f-14 total-text">
            <span class="f-18 fw-b color-red ml-20">合计收益：{{+info.price|parseMoney}}</span>
            <div>
                统计于：<span class="color-grays">{{info.stat_time}}</span> 至 <span
                    class="color-grays">{{info.end_time}}</span>
            </div>
        </div>
        <div class="chart-content">
            <BarChart :chart-data="chartData"></BarChart>
        </div>
        <div class="bottom-content">
            <div class="bottom-row">
                <div>基本房费：<span class="color-red">{{details.house_price|parseMoney}}</span></div>
                <div>清洁费：<span class="color-red">{{details.clean_price|parseMoney}}</span></div>   
                <div>服务费：<span class="color-red">{{details.serve_price|parseMoney}}</span></div>
            </div>
            <div class="mt-20">入住率：<span class="color-red f-20">{{details.ratio}}</span></div>
            <div class="mt-20 mb-10">总体评分</div>
            <el-rate :value="+details.star|| 0"
                     disabled
                     show-score
                     disabled-void-color="#cccccc"
                     text-color="#ff9900"
                     style="display: flex;justify-content: flex-start;align-items: center"
                     score-template="{value}"></el-rate>
            <div class="mt-20 mb-10">浏览量</div>
            <span class="color-red f-18">{{details.view_count}}</span>
        </div>
    </div>
</template>

<script>
    import BarChart from "../../components/BarChart";

    export default {
        name: "statisticsLandord",
        components: {BarChart},
        data() {
            return {
                timeType: [
                    {id: 1, name: '日收益'},
                    {id: 2, name: '月收益'},
                    {id: 3, name: '年收益'}
                ],
                form: {
                    type: 3,
                    time: '2020',
                },
                chartData: {},
                info: '',
                details: ''
            }
        },
        watch: {
            'form.type'() {
                this.form.time = '';
            }
        },
        created() {
            this.landlordDataInfo()
        },
        methods: {
            async landlordDataInfo() {
                if (!this.form.time) {
                    return this.$message.warning('请选择时间')
                }
                let [e, data] = await this.$api.landlordDataInfoApi(this.form)
                this.chartData = data.result.state;
                this.info = data.result.info;
                this.details = data.result.details;
            }
        },
    }
</script>

<style scoped lang="less">
    .chart-content {
        width: 100%;
        height: 300px;
    }

    .total-text {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    }

    .bottom-content {
        flex-flow: column;
        display: flex;
        justify-content: center;
        align-items: center;
        .bottom-row{
            display: flex;
            justify-content: space-around;
            align-items: center;
            width: 100%;
        }
    }
</style>
